import React from 'react';
import {useIntl} from 'react-intl';
import cn from 'classnames';

import {useUI} from 'coreHooks';

import Button from 'brandComponents/Button';
import Typography from 'brandComponents/Typography';

import {IAuthLoginContentProps} from './IAuthLoginContent';
import messages from './messages';

import styles from './AuthLoginContent.module.scss';

const AuthLoginContent = ({onClick, classNames, children}: IAuthLoginContentProps) => {
	const intl = useIntl();
	const isRequiresLoginEnabled = useUI('requiresLoginFeature')?.enabled;

	return (
		<section className={cn(styles['auth__login-content__wrapper'], classNames)}>
			<Typography variant="h2" classNames={styles['auth__login-content__title']}>
				{intl.formatMessage(messages.contentTitle)}
			</Typography>

			<div className={styles['auth__login-content__benefits']}>
				{intl.formatMessage(messages.contentBenefits, {
					benefits: (chunk) => <ul>{chunk}</ul>,
					item: (chunk) => <li>{chunk}</li>,
					requiresText: (chunk) => (
						<li className={cn({[styles['auth__login-content__requires--hidden']]: !isRequiresLoginEnabled})}>{chunk}</li>
					),
				})}
			</div>

			{children}

			<div className={styles['auth__login-content__buttons']}>
				<Button onClick={onClick} type="button">
					{intl.formatMessage(messages.contentSubmit)}
				</Button>
			</div>
		</section>
	);
};

export default AuthLoginContent;
